// ========================================
// INTERNATIONALIZATION (i18n) CONFIGURATION
// ========================================

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import en from './locales/en.json';
import th from './locales/th.json';

// ========================================
// LANGUAGE CONFIGURATION
// ========================================

const resources = {
    en: { translation: en },
    th: { translation: th }
};

// ========================================
// i18n INITIALIZATION
// ========================================

i18n
    // Detect user language
    .use(LanguageDetector)
    // Pass the i18n instance to react-i18next
    .use(initReactI18next)
    // Initialize i18next
    .init({
        resources,
        fallbackLng: 'en',
        defaultNS: 'translation',

        // Language detection options
        detection: {
            // Order of detection methods
            // Only use localStorage - ensures English default for new users
            // Users can switch language via UI, which saves to localStorage
            order: ['localStorage'],
            // Keys to lookup language in
            lookupLocalStorage: 'ask-operations-language',
            // Cache user language in localStorage
            caches: ['localStorage'],
        },

        interpolation: {
            escapeValue: false, // React already does escaping
        },

        // Debug mode (disable in production)
        debug: process.env.NODE_ENV === 'development',
    });

// ========================================
// LANGUAGE HELPER FUNCTIONS
// ========================================

/**
 * Get current language code
 * @returns {string} Current language code ('en' or 'th')
 */
export const getCurrentLanguage = () => i18n.language || 'en';

/**
 * Change the current language
 * @param {string} lang - Language code ('en' or 'th')
 */
export const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    // Store in localStorage for persistence
    localStorage.setItem('ask-operations-language', lang);
};

/**
 * Get available languages
 * @returns {Array} Array of language objects with code and name
 */
export const getAvailableLanguages = () => [
    { code: 'en', name: 'English', nativeName: 'English' },
    { code: 'th', name: 'Thai', nativeName: 'ไทย' }
];

export default i18n;
